import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { type ClassMap, makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexCenter,
    padding: '2rem 2rem',
  },
}));

export interface LoadingAreaProps {
  classes?: ClassMap<'container'>;
}

export const LoadingArea: React.FC<LoadingAreaProps> = (props) => {
  const classes = useStyles();

  const { classes: customClasses = {} } = props;

  return (
    <div className={clsx(classes.container, customClasses.container)}>
      <CircularProgress color="primary" size="4rem" />
    </div>
  );
};
